// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".questionnaire-table-component .non-sended[data-v-0d53c503]{color:#d94a7d;font-weight:700}.questionnaire-table-component .answers-list-btn[data-v-0d53c503],.questionnaire-table-component .delete-btn[data-v-0d53c503],.questionnaire-table-component .edit-btn[data-v-0d53c503]{width:64px}.questionnaire-table-component .copy-btn[data-v-0d53c503]{width:80px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
